// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed, set } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { tKey } from 'ember-intl';
import GeneralDatepickersDatepickerRange from 'lumen/components/general/datepickers/datepicker-range';
import GeneralDatepickersDatepickerSharedTemplate from 'lumen/components/general/datepickers/datepicker-shared-template';
import GeneralDropdownsSidebar from 'lumen/components/general/dropdowns/sidebar';
import {
  AVAILABLE_RATECHANGES,
  COMPARETYPES,
} from 'lumen/utils/constants/general-constants';

export default class GeneralDatepickersDatepickerWithCompare extends GeneralDatepickersDatepickerRange {
  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  @tracked tempOption = null;

  @computed(
    'args.{compareDisabledTooltipText,compareType,compareValue,isCompareDisabled}',
    'isCompareDisabled',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dateCompareOptions() {
    const dateCompareOptions = [
      {
        id: COMPARETYPES.NO_COMPARE,
        text: tKey('general.no_comparison'),
        compareType: COMPARETYPES.NO_COMPARE,
        compareValue: COMPARETYPES.NO_COMPARE,
        // @ts-expect-error: Incorrect type
        isSelected: this.args.compareType === COMPARETYPES.NO_COMPARE,
      },
    ];

    AVAILABLE_RATECHANGES.forEach((rateChangeDay) => {
      const compareValueForDay = this.hotelAndMarketService
        .getLocalTime()
        .startOf('day')
        .subtract(rateChangeDay, 'day')
        .format('YYYY-MM-DD');
      dateCompareOptions.push({
        // @ts-expect-error: Incorrect type
        id: rateChangeDay,
        // @ts-expect-error: Incorrect type
        text: 'general.daysago',
        count: rateChangeDay, // Used for translations
        // @ts-expect-error: Incorrect type
        compareType: COMPARETYPES.DATE,
        // @ts-expect-error: Incorrect type
        compareValue: compareValueForDay,
        isSelected:
          // @ts-expect-error: Incorrect type
          this.args.compareType === COMPARETYPES.DATE &&
          // @ts-expect-error: Incorrect type
          this.args.compareValue === compareValueForDay,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        isDisabled: this.args.isCompareDisabled,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        disabledText: this.args.compareDisabledTooltipText,
      });
    });

    dateCompareOptions.push({
      // @ts-expect-error: Incorrect type
      id: COMPARETYPES.SWLY,
      // @ts-expect-error: Incorrect type
      text: 'general.versus.swly_short',
      // @ts-expect-error: Incorrect type
      compareType: COMPARETYPES.SWLY,
      // @ts-expect-error: Incorrect type
      compareValue: 'true',
      // @ts-expect-error: Incorrect type
      isSelected: this.args.compareType === COMPARETYPES.SWLY,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      isDisabled: this.isCompareDisabled,
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      disabledText: this.args.compareDisabledTooltipText,
    });

    return dateCompareOptions;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get footerMessage() {
    // @ts-expect-error: Incorrect type
    if (!this.args.isTableView) {
      return this.intl.t('general.redirecting_for_comparison');
    }
    return null;
  }

  @computed('tempOption.{compareType,compareValue}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasActiveCompare() {
    return (
      this.tempOption &&
      // @ts-expect-error: Incorrect type
      this.tempOption.compareType !== COMPARETYPES.NO_COMPARE &&
      // @ts-expect-error: Incorrect type
      this.tempOption.compareValue !== COMPARETYPES.NO_COMPARE
    );
  }

  @computed(
    'args.{compareType,compareValue}',
    'tempOption.{compareType,compareValue}',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasCompareChanged() {
    return (
      this.tempOption !== null &&
      // @ts-expect-error: Incorrect type
      (this.tempOption.compareType !== this.args.compareType ||
        // @ts-expect-error: Incorrect type
        this.tempOption.compareValue !== this.args.compareValue)
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isApplyDisabled() {
    return !this.hasRangeChanged && !this.hasCompareChanged;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDateCompareDisabled() {
    return (
      // @ts-expect-error: Incorrect type
      this.dateCompareOptions.filter((dateCompare) => dateCompare.isDisabled)
        .length > 0
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get noCompare() {
    return this.dateCompareOptions.find(
      (dateCompare) => dateCompare.id === COMPARETYPES.NO_COMPARE,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get sidebarLists() {
    return [
      {
        id: 'compare',
        title: this.intl.t('general.compare'),
        options: this.dateCompareOptions,
      },
    ];
  }

  @action
  // @ts-expect-error: Incorrect type
  applyChanges(dropdown): void {
    if (this.hasActiveCompare) {
      this.usageAnalytics.track('Daily Rates Compared', {
        eventTrigger: 'date-picker',
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        compareType: this.tempOption.compareType,
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        compareValueFrom: this.tempOption.compareValue,
        compareValueTo: this.hotelAndMarketService
          .getLocalTime()
          .format('YYYY-MM-DD'),
      });
    }

    // Redirect to the table view if we start comparing in a view other than the table view
    // @ts-expect-error: Incorrect type
    if (!this.args.isTableView && this.hasActiveCompare) {
      // @ts-expect-error: Incorrect type
      const { compareType, compareValue } = this.tempOption;
      const queryParams = {
        view: 'table',
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        month: this.tempRange.start.format('YYYY-MM'),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        compareType,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        compareValue,
      };

      this.router.transitionTo('hotel.rates', { queryParams });
    } else {
      // changeRange also triggers updateCompare()
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.changeRangeTask.perform(this.tempRange);
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    dropdown.toggleDropdown();
  }

  @action
  // @ts-expect-error: Incorrect type
  disableInvalidDateCompares(isDisabled): void {
    this.dateCompareOptions.forEach((dateCompare) => {
      if (
        // @ts-expect-error: Incorrect type
        dateCompare.compareType === COMPARETYPES.DATE ||
        // @ts-expect-error: Incorrect type
        dateCompare.compareType === COMPARETYPES.SWLY
      ) {
        set(dateCompare, 'isDisabled', isDisabled);
        if (isDisabled) {
          set(dateCompare, 'isSelected', false);
        }
      }
    });
  }

  @action
  initSelectedDateCompare(): void {
    // @ts-expect-error: Incorrect type
    if (this.args.compareType === null && this.args.compareValue === null) {
      this.setSelectedDateCompare(this.noCompare);
    } else {
      // If we updated the date compare using the compare menu: make sure the correct date compare is reflected in the datepicker sidebar
      this.dateCompareOptions.forEach((dateCompare) => {
        set(
          dateCompare,
          'isSelected',
          // @ts-expect-error: Incorrect type
          dateCompare.compareType === this.args.compareType &&
            // @ts-expect-error: Incorrect type
            dateCompare.compareValue === this.args.compareValue,
        );
      });
    }
  }

  @action
  onCancel(): void {
    this.revertDateCompare();
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super.onCancel(...arguments);
  }

  @action
  revertDateCompare(): void {
    // Revert temporary changes
    const originalDateCompare = this.dateCompareOptions.find(
      (dateCompare) =>
        // @ts-expect-error: Incorrect type
        dateCompare.compareType === this.args.compareType &&
        // @ts-expect-error: Incorrect type
        dateCompare.compareValue === this.args.compareValue,
    );

    // Add this check because a compare might be active that is not a date compare (ratetype, mealtype, roomtype, etc).
    if (originalDateCompare) {
      this.setSelectedDateCompare(originalDateCompare);
    }

    this.tempOption = null;
  }

  @action
  // @ts-expect-error: Incorrect type
  selectOption(option): void {
    // Only update the selection if the option wasn't already selected
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!option.isSelected) {
      this.setSelectedDateCompare(option);
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  selectRange(selectedRange): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const { start } = selectedRange.moment;
    // Disable date compare for past months and when All Channels OTA filter is selected.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const shouldDateCompareBeDisabled = start.isBefore(
      this.hotelAndMarketService.getLocalTime(),
      'month',
    );

    if (this.isDateCompareDisabled && !shouldDateCompareBeDisabled) {
      this.disableInvalidDateCompares(false);
    } else if (!this.isDateCompareDisabled && shouldDateCompareBeDisabled) {
      this.disableInvalidDateCompares(true);
      // Set compare to "vs. None" when a range in the past is selected
      this.setSelectedDateCompare(this.noCompare);
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line prefer-rest-params
    super.selectRange(...arguments);
  }

  @action
  // @ts-expect-error: Incorrect type
  setSelectedDateCompare(option): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.tempOption = option;
    this.dateCompareOptions.forEach((dateCompare) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      set(dateCompare, 'isSelected', dateCompare.id === option.id);
    });
  }

  @action
  updateCompare(): void {
    if (this.hasCompareChanged) {
      // @ts-expect-error: Incorrect type
      const { compareType, compareValue } = this.tempOption;

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.selectionsChanged('compareType', compareType);
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.selectionsChanged('compareValue', compareValue);
    }
    this.tempOption = null;
  }

  <template>
    <GeneralDatepickersDatepickerSharedTemplate
      @applyChanges={{this.applyChanges}}
      @beginReached={{this.beginReached}}
      @calendarFocusOnEnd={{@calendarFocusOnEnd}}
      @canSelectMonth={{this.canSelectMonth}}
      @cancelChanges={{this.cancelChanges}}
      @displayEvents={{@displayEvents}}
      @endReached={{this.endReached}}
      @footerMessage={{this.footerMessage}}
      {{! @glint-expect-error: Incorrect type }}
      @hasEventAccess={{this.access.hasEvents}}
      @isApplyDisabled={{this.isApplyDisabled}}
      @maxDate={{this.convertedMaxDate}}
      @maxRange={{@maxRange}}
      @minDate={{this.convertedMinDate}}
      @nextClicked={{this.nextClicked}}
      @onCancel={{this.onCancel}}
      @previousClicked={{this.previousClicked}}
      @range={{this.convertedRange}}
      @refocusMonths={{this.refocusMonths}}
      @selectRange={{this.selectRange}}
      @showMonthDropdowns={{@showMonthDropdowns}}
      @standardRange={{@standardRange}}
      @tempRange={{this.tempRange}}
      @triggerLabel={{@triggerLabel}}
      @updateTempRange={{this.updateTempRange}}
    >
      <:sidebar>
        <GeneralDropdownsSidebar
          @selectOption={{this.selectOption}}
          @sidebarLists={{this.sidebarLists}}
          {{! @glint-expect-error: Incorrect type }}
          {{didInsert this.initSelectedDateCompare}}
        />
      </:sidebar>
    </GeneralDatepickersDatepickerSharedTemplate>
  </template>
}
